export default "data:image/gif;base64,R0lGODlhAwADAIABAMzb/f///ywAAAAAAwADAAACA4QfWQA7"